import React from 'react';
import { Link } from 'react-router';

import { Button } from 'src/common/components/button/button';

import './footer-link.css';

type FooterLinkProps = {
  href?: string;
  label: string;
  icon?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const FooterLink = ({ href, label, icon, onClick }: FooterLinkProps) => {
  const content = (
    <>
      {icon && <span className="footer-v3-link__icon">{icon}</span>}
      {label}
    </>
  );

  if (onClick) {
    return (
      <Button onClick={onClick} variant="link" className="footer-v3-btn">
        {content}
      </Button>
    );
  }

  if (href?.startsWith('http')) {
    return (
      <a
        href={href}
        target="_blank"
        className="footer-v3-link"
        rel="noreferrer"
      >
        {content}
      </a>
    );
  }

  return (
    <Link to={href || ''} className="footer-v3-link">
      {content}
    </Link>
  );
};
